<template>
  <div class="question-listing">
    <vs-row class="mb-8">
      <vs-col vs-w="12">
        <div class="float-right flex">
          <vs-button
            color="maroon"
            type="filled"
            class="btn-color"
            icon-pack="feather"
            icon="icon-filter"
            @click="showfilter = !showfilter"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="warning"
            type="filled"
            icon-pack="feather"
            icon="icon-download"
            @click="showImport = !showImport"
            class="btn-color ml-4"
            >{{ $t("labels.import") }}</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-upload"
            @click.prevent="exportCsv()"
            class="btn-color ml-4"
            >{{ $t("labels.export") }}</vs-button
          >
        </div>
      </vs-col>
    </vs-row>
    <vx-card class="filter-card mb-6" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/2">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="search"
            class="w-full"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.vessel") }}</label>
          <v-select
            v-model="vessel_type_id"
            :options="filtersVessel"
            :reduce="(filtersVessel) => filtersVessel.id"
            label="name"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.service") }}</label>
          <v-select
            v-model="service_id"
            :options="filterService"
            :reduce="(filterService) => filterService.id"
            label="name"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3" v-if="this.isUserType('A')">
          <label class="pl-1">{{ $t("labels.client") }}</label>
          <v-select
            v-model="client_id"
            :options="filtersClient"
            :reduce="(filtersClient) => filtersClient.id"
            label="name"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.section") }}</label>
          <v-select
            v-model="section_id"
            :options="filterSection"
            :reduce="(filterSection) => filterSection.id"
            label="name"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.designation") }}</label>
          <v-select
            v-model="designation"
            :options="designations_drop"
            :reduce="(designations_drop) => designations_drop.id"
            label="name"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/2 flex mt-5">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            :title="$t('labels.filter')"
            @click.prevent="filter()"
            :disabled="
              !this.search &&
              !this.filtersVessel &&
              !this.filterService &&
              !this.filterSection &&
              !this.filtersClient &&
              !this.designations_drop
            "
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.filter')"
            @click="clearFilter()"
            :disabled="
              !this.search &&
              !this.filtersVessel &&
              !this.filterService &&
              !this.filterSection &&
              !this.filtersClient &&
              !this.designations_drop
            "
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="question-import" v-show="showImport == true">
      <div class="vx-row filter-default">
        <div
          class="vx-col sm: w-full md:w-1/4 flex sm: justify-center md:justify-end"
        >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-download"
            :title="$t('labels.download_sample_csv')"
            @click.prevent="downloadSampleCsv()"
            class="btn-color"
            >{{ $t("labels.sample_import_csv") }}</vs-button
          >
        </div>
        <div class="vx-col sm: w-full md:w-1/3 sm:pl-5">
          <input
            type="file"
            id="file"
            name="importFile"
            class="vs-inputx vs-input--input normal hasValue"
            accept=".csv"
            ref="file"
            v-on:change="handleFileUpload(this)"
            v-validate="'verify_image'"
          />
        </div>
        <div
          class="vx-col sm: w-full md:w-2/5 flex sm: justify-center md:justify-start"
        >
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.clear')"
            @click="clearImport()"
            class="sm:ml-0 md:ml-2 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-upload"
            :title="$t('labels.import_csv')"
            @click.prevent="submitFile()"
            class="sm:ml-0 px-10 btn-color float-left"
            >{{ $t("labels.import") }}
          </vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card :title="$t('labels.questionnaire')" class="lead-listing">
      <div class="status">
        <vs-chip color="primary" class="status-name">
          {{ $t("labels.total") }}:- {{ count }} Questions
        </vs-chip>
      </div>
      <div class="vx-row w-full m-0 list-header">
        <div
          class="vx-col sm: w-1/2 md:w-1/2 mb-4 set_limit pl-0 pr-0 justify-between"
        >
          <div class="set flex">
            <label class="limit_label">{{ $t("labels.show") }}</label>
            <v-select
              v-model="limit"
              :options="limitarr"
              :reduce="(limitarr) => limitarr.value"
              :clearable="false"
              label="text"
              class="px-1"
            />
            <label class="limit_label">{{ $t("labels.questions") }}</label>
          </div>
        </div>
        <div
          class="vx-col sm: w-1/2 md:w-1/2 pl-0 pr-0 justify-flex-end addbtn-col mb-6"
        >
          <router-link :to="{ name: 'QuestionAdd' }">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="float-right btn-add sm: mb-4 md:m-0"
              v-if="checkPermission('question', 'add')"
              >{{ $t("labels.add_question") }}</vs-button
            >
          </router-link>
        </div>
      </div>
      <vs-table :data="questions" class="permission">
        <template slot="thead">
          <vs-th class="col-md-5">{{ $t("labels.name") }}</vs-th>
          <vs-th class="col-md-3">{{
            $t("labels.section_reference_number")
          }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.status") }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.action") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.question">{{ tr.question }}</vs-td>
            <vs-td :data="tr.section_reference_number">{{
              tr.section_reference_number
            }}</vs-td>
            <vs-td :data="tr.importance_name">{{ tr.importance_name }}</vs-td>
            <vs-td width="175">
              <div class="flex">
                <vs-button
                  type="flat"
                  :title="$t('labels.view')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-eye"
                  class="mr-2"
                  color="dark"
                  @click="
                    $router.push({
                      name: 'QuestionView',
                      params: { id: tr.id },
                    })
                  "
                  v-if="checkPermission('question', 'view')"
                ></vs-button>
                <vs-button
                  type="flat"
                  :title="$t('labels.edit')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="mr-2"
                  @click="
                    $router.push({
                      name: 'QuestionEdit',
                      params: { id: tr.id },
                    })
                  "
                  v-if="checkPermission('question', 'modify')"
                ></vs-button>

                <vs-button
                  @click="deleteConfirm(indextr)"
                  type="flat"
                  :title="$t('labels.delete')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  color="danger"
                  v-show="
                    tr.status !== 'W' && checkPermission('question', 'delete')
                  "
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      questions: [],
      totalPage: 1,
      currentx: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      // limit: this.$store.state.limit,
      showfilter: false,
      showImport: false,
      // search: null,
      file: null,
      sample_csv_url: null,
      count: 0,
      search: this.$store.state.queTabs,
      vessel_type_id: null,
      filtersVessel: [],
      service_id: null,
      filterService: [],
      section_id: null,
      filterSection: [],
      client_id: null,
      filtersClient: [],
      designation: null,
      designations_drop: [],
    };
  },
  computed: {},
  watch: {
    limit(val) {
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getQuestions();
    },
    search(val) {
      this.currentx = 1;
    },
    currentx(val) {
      this.getQuestions();
    },
    showImport(val) {
      if (val) {
        this.showfilter = false;
      }
    },
    showfilter(val) {
      if (val) {
        this.showImport = false;
      }
    },
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    this.getQuestions();
    this.getVessel();
    this.getService();
    this.getSection();
    this.getClients();
    this.getDesignations();
  },
  methods: {
    async getQuestions(exp = false) {
      let input = {
        page: this.currentx,
        perPage: this.limit,
        search: this.search,
        vessel_type_id: this.vessel_type_id,
        service_id: this.service_id,
        section_id: this.section_id,
        client_id: this.client_id,
        designation_id: this.designation,
      };
      if (exp) {
        input = Object.assign(
          {
            export: true,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse("/questions/list", input);
      if (exp) {
        this.exportFile(response, "Questions");
      }
      if (!exp) {
        if (response) {
          let data = response.data;
          let questions = data.questions;
          let perPage = this.limit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          this.questions = questions;
          this.sample_csv_url = data.sample_csv;
          this.count = response.data.count;
        }
      }
    },
    async submitFile() {
      let data = new FormData();
      data.set("file", this.importFile);
      let response = await this.getHTTPPostResponse(
        "/questions/import",
        data,
        "",
        true
      );
      if (response) {
        let data = response.data;
        this.showImport = false;
        document.getElementById("file").value = "";
        this.getQuestions();
      }
    },
    handleFileUpload() {
      let file = this.$refs.file.files[0];

      if (file.type !== "text/csv") {
        this.$refs.file.value = "";
      }
      this.importFile = this.$refs.file.files[0];
    },
    exportCsv() {
      this.getQuestions(true);
    },
    filter() {
      this.currentx = 1;
      this.$store.commit("QUESTION_TAB", this.search);
      this.getQuestions();
    },
    clearFilter() {
      this.search = null;
      this.vessel_type_id = null;
      this.service_id = null;
      this.section_id = null;
      this.client_id = null;
      this.designation = null;
      this.getQuestions();
    },
    clearImport() {
      document.getElementById("file").value = "";
      this.getQuestions();
    },
    deleteConfirm(index) {
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.confirmation"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.deleteQuestion,
      });
    },
    async deleteQuestion() {
      if (this.index < 0) return;
      let url = "questions/delete";
      let ids = [];
      let index = this.index;
      ids.push(this.questions[index].id);
      let input = {
        ids: ids,
      };
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.getQuestions();
      }
    },
    downloadSampleCsv() {
      window.open(this.sample_csv_url, "_self");
    },
    async getVessel() {
      var input = {
        only_parents: true,
        with_children: true,
      };
      let response = await this.getHTTPPostResponse("/vesselType/list", input);
      if (response) {
        let types = response.data.vesselTypes;
        this.filtersVessel = types;
      }
    },
    async getService() {
      var input = {};
      let response = await this.getHTTPPostResponse("/services/list", input);
      if (response) {
        let services = response.data.services;
        this.filterService = services;
      }
    },
    async getSection() {
      let input = {
        only_parents: true,
      };
      let response = await this.getHTTPPostResponse("/sections/list", input);
      if (response) {
        let sections = response.data.sections;
        this.filterSection = sections;
      }
    },
    async getClients() {
      var input = {
        type: "CL",
      };
      let response = await this.getHTTPPostResponse("/users", input);
      if (response) {
        let data = response.data.users;
        let client = data;
        this.filtersClient = client;
      }
    },
    async getDesignations() {
      let input = {
        name: this.designation,
      };
      let response = await this.getHTTPPostResponse(
        "/designations/list",
        input
      );
      if (response) {
        let designation_req = response.data.designations;
        let filteredDesignations = [];
        for (var i = 0; i < designation_req.length; i++) {
          let obj = {
            id: designation_req[i].id,
            name: designation_req[i].name,
          };
          filteredDesignations.push(obj);
        }
        this.designations_drop = filteredDesignations;
      }
    },
  },
};
</script>
<style scoped>
p {
  font-weight: 600;
}
</style>
